import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useState } from "react";
import { AirQualityDetails } from "../mainLayer/airQuality/airQuality";

// Define the context type
type AirQualityContextType = {
  AirQualityOpenSidebarMap: Map<string, AirQualityDetails>;
  setAirQualityOpenSidebarMap: (
    type: string,
    ewsopenMap: AirQualityDetails
  ) => void;
  removeFromAirQualityOpenSidebarMap: (active_pcode: string) => void;
  clearAirQualityOpenSidebarMap: () => void;
  clickedAirQualityString: string | null;
  setClickedAirQualityString: (value: string) => void;
  isLeftkeyClick: boolean;
  setIsLeftkeyClick: (value: boolean) => void;
  isLeftAir: boolean;
  setIsLeftAir: (value: boolean) => void;
  isMinEyeClickAir: boolean;
  setIsMinEyeClickAir: (value: boolean) => void;
  isMinLoad: boolean;
  setIsMinLoad: (value: boolean) => void;
};

const AirQualityContext = createContext<AirQualityContextType | undefined>(
  undefined
);

export const AirQualityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [AirQualityOpenSidebarMap, setAirQualityOpenSidebarMapState] = useState(
    new Map<string, AirQualityDetails>()
  );
  const [clickedAirQualityString, setClickedAirQualityString] = useState<
    string | null
  >(null);
  const [isLeftkeyClick, setIsLeftkeyClick] = useState(false);
  const [isLeftAir, setIsLeftAir] = useState(false);
  const [isMinEyeClickAir, setIsMinEyeClickAir] = useState(false);
  const [isMinLoad, setIsMinLoad] = useState(false);

  const setAirQualityOpenSidebarMap = (
    type: string,
    AirQualityopenMap: AirQualityDetails
  ) => {
    setAirQualityOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(type, AirQualityopenMap);
      return newMap;
    });
  };

  const removeFromAirQualityOpenSidebarMap = (sensorId: string) => {
    setAirQualityOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.delete(sensorId);
      return newMap;
    });
  };

  const clearAirQualityOpenSidebarMap = () => {
    setAirQualityOpenSidebarMapState(new Map());
  };



  // Provide the state and the updater functions
  return (
    <AirQualityContext.Provider
      value={{
        AirQualityOpenSidebarMap,
        setAirQualityOpenSidebarMap,
        removeFromAirQualityOpenSidebarMap,
        clearAirQualityOpenSidebarMap,
        clickedAirQualityString,
        setClickedAirQualityString,
        isLeftkeyClick,
        setIsLeftkeyClick,
        isLeftAir,
        setIsLeftAir,
        isMinEyeClickAir,
        setIsMinEyeClickAir,
        isMinLoad,
        setIsMinLoad,
      }}
    >
      {children}
    </AirQualityContext.Provider>
  );
};

// Custom hook for using AirQualityContext
export const useAirQualityContext = () => {
  const context = useContext(AirQualityContext);
  if (!context) {
    throw new Error("useHzContext must be used within an HzProvider");
  }
  return context;
};
